import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import React from 'react'
import styled from 'styled-components'

import { GetCustomerCartQuery } from '../../../graphql/magento'
import {
  CartState,
  ToggleCodesAction,
  ToggleSummaryAction,
} from '../../../lib/cart/reducers/cart-state'
import CartPromoCode from '../../cart/CartPromoCode'
import CartSummary from '../../cart/CartSummary'
import CartSummaryToggle from '../../cart/CartSummaryToggle'

const StyledCartSummaryToggle = styled(CartSummaryToggle)`
  padding-left: 0;
  padding-right: 0;
`

export interface MiniCartModalFooterProps
  extends Pick<CartState, 'codesCollapsed' | 'summaryVisible'> {
  className?: string
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  disableButtons: boolean
  dispatch: React.Dispatch<ToggleCodesAction | ToggleSummaryAction>
  handleCloseCart(e?: React.BaseSyntheticEvent): void
}

const MiniCartModalFooter = React.forwardRef<HTMLElement, MiniCartModalFooterProps>(
  (
    { cart, className, codesCollapsed, disableButtons, dispatch, handleCloseCart, summaryVisible },
    ref,
  ) => (
    <footer className={className} ref={ref}>
      <CartPromoCode
        cart={cart}
        codesCollapsed={codesCollapsed}
        dispatch={dispatch}
        formDisabled={false}
      />
      <CartSummary cart={cart} summaryVisible={summaryVisible} />
      <StyledCartSummaryToggle cart={cart} dispatch={dispatch} summaryVisible={summaryVisible} />
      <PrimaryButton disabled={disableButtons} onClick={handleCloseCart}>
        Proceed to Checkout
      </PrimaryButton>
    </footer>
  ),
)

MiniCartModalFooter.displayName = 'MiniCartModalFooter'

const StyledMiniCartModalFooter = styled(MiniCartModalFooter)`
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border-top: 1px solid ${({ theme }) => theme.colors.coolGray.cool250};
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 416px;
  min-height: 114px;
  padding: 15px;
  position: fixed;
  right: 0;
  width: 100%;
`

export default StyledMiniCartModalFooter
